<template>
    <Layout is-crm class="transitions-node" :content-class="layerClasses">
        <template #default>
            <Spinner v-if="loading" />

            <template v-if="node">
                <TransitionsGraph
                    :node="node"
                    :states="states"
                    :actions="actions"
                    @update:actions="actions = $event"
                />
            </template>
        </template>
    </Layout>
</template>

<script>
import { fetchNode, fetchGraph } from '../../api/metas';
import { TransitionsGraph } from '../../components';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';

export default {
    name: 'TransitionsNodePage',
    components: {
        TransitionsGraph,
        Layout,
    },
    data() {
        return {
            loading: false,
            node: undefined,
            actions: [],
            version: null,
        };
    },
    computed: {
        states() {
            if (!this.node) return {};

            const { locale } = this.$i18n;
            let { source_state, destination_state } = this.node;

            if (!source_state)
                source_state = {
                    label: {
                        [locale]: '—',
                    },
                    on: [],
                };

            source_state.on = [...this.actions];
            destination_state.type = 'final';

            return { source_state, destination_state };
        },
        backRoute() {
            return { name: 'transitions' };
        },
        layerClasses() {
            const hasActions = !!this.actions.length;
            return {
                'content--narrow': !hasActions,
                'content--centered': hasActions,
            };
        },
    },
    async created() {
        this.loading = true;
        await this.fetchNode();
        await this.fetchGraph();
        this.loading = false;
    },
    methods: {
        async fetchNode() {
            try {
                const { params: { id } = {} } = this.$route;
                this.node = await fetchNode(id);
            } catch (err) {
                console.log(err);
                this.$router.push(this.backRoute);
            }
        },
        async fetchGraph() {
            const { id } = this.node;
            if (!id) throw new Error('node.id must be defined');

            try {
                const { version, graph } = await fetchGraph(id);
                this.version = version;
                this.actions = graph;
            } catch (err) {
                console.log(err);
            }
        },
    },
};
</script>
